import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { spaces } from '../../docs-routes'

const SpaceInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Use spaces to organize and separate related test resources. Each space has its own access controls. Resources in the shared space are accessible to all users and can be used across other spaces.
    </Color>
    <DocusaurusFooter path={spaces} />
  </Paragraph>

export default SpaceInfo
